"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NobelPrize = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const CardRenderItem_1 = require("../render/CardRenderItem");
const Size_1 = require("../render/Size");
class NobelPrize extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.NOBEL_PRIZE,
            tags: [Tags_1.Tags.WILDCARD],
            metadata: {
                cardNumber: 'P54',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(5);
                    b.cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.REQ).nbsp(Size_1.Size.TINY);
                    b.cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.REQ);
                }),
                description: 'Gain 5 M€. Draw 2 cards with requirements.',
                victoryPoints: 2,
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.MEGACREDITS, 5);
        player.drawCard(2, {
            include: (card) => card.requirements !== undefined,
        });
        return undefined;
    }
    getVictoryPoints() {
        return 2;
    }
}
exports.NobelPrize = NobelPrize;
//# sourceMappingURL=NobelPrize.js.map